import Repository from "./repository"

export default {
    /**
     * 見積書一覧取得処理
     * @param object params リクエストパラメータ
     * @returns response
     */
    view(params) {
        return Repository.get("/api/s214-quotation/view", { params: params })
    },
    /**
     * S21402_見積書作成処理
     *
     * @param object params リクエストパラメータ
     * @returns response
     */
    create(params) {
        return Repository.post("/api/s214-quotation/create", params)
    },
    /**
     * S21403_見積内容取得処理
     *
     * @param object params リクエストパラメータ
     * @return response
     */
    detail(params) {
        return Repository.get("/api/s214-quotation/detail/view", { params: params })
    },
    /**
     * 見積書取得処理
     * @param object params リクエストパラメータ
     * @returns response
     */
    get(params) {
        return Repository.get("/api/s214-quotation/get", { params: params })
    },
    /**
     * 見積書削除処理
     * @param object params リクエストパラメータ
     * @returns response
     */
    delete(params) {
        return Repository.put("/api/s214-quotation/delete", params)
    },
    /**
     * S21406_プラン変更見積書作成処理
     *
     * @param object params リクエストパラメータ
     * @return response
     */
    createPlanChange(params) {
        return Repository.post("/api/s214-quotation/plan-changes-create", params)
    },
    /**
     * S21407_プラン変更内容取得処理
     *
     * @param object params リクエストパラメータ
     * @return response
     */
    planChangeDetail(params) {
        return Repository.get("/api/s214-quotation/plan-changes-detail/view", { params: params })
    },
    /**
     * S21408_更新見積書作成処理
     *
     * @param object params リクエストパラメータ
     * @returns response
     */
    createUpdateQuotation(params) {
        return Repository.post("/api/s214-quotation/create-update-quotation", params)
    },
}
